import React, {Component} from 'react'
import axios from 'axios'
import {connect} from 'react-redux'
import {
    Page,
} from '../components'
import '../styles/question/QuestionPage.css'
import defaultImg from '../images/no-source.png'
import {
    Cell,
    CellBody,
    CellFooter,
    CellsTitle,
    LoadMore
} from 'react-weui';
import glImg from '../images/gonglve.jpg'
import config from '../config'

class QuestionCategoryDetail extends Component {

    constructor(props) {
        super(props);
        this.state={
            results: [],
            categoryTitle: "所属分类",
            initialized: false,
       };
    }

    componentDidMount(){
        let params = this.props.params;
        let category_id = params.category_id;
        axios.get(`/api/qa/tutorial/list/${category_id}`).then((response) => {
            const {items, category} = response.data.data
            if (response.data.code === 0) {
                this.setState({
                    results: items,
                    categoryTitle: category.name,
                    initialized: true,
                });
            }
        });

        // init sharedata
        this.props.dispatch({
            type: 'UPDATE_SHARE_DATA',
            payload: {
                title: '最全功能介绍',
                desc: '你想要的答案都在这里',
                imgUrl: glImg,
                type: 'link',
                link: window.location.href,
            }
        });
    }

    render() {
        const {initialized} = this.state;
        if (!initialized) {
            return (
                <Page>
                    <div className="question-page-div">
                        <LoadMore loading />
                    </div>
                </Page>
            )
        }

        return (
            <Page>
                <div className="question-page-div">
                    <CellsTitle className="question-title">{this.state.categoryTitle}</CellsTitle>
                    <div className="question-font_16">
                        {
                            this.state.results.length > 0 ?
                            this.state.results.map((item,i)=>{
                            return(
                                <Cell href={item.url} key={item.id} access className="question-content">
                                    <CellBody className='text-overflow-content'>
                                        <p className="text-overflow">{item.title}</p>
                                    </CellBody>
                                    <CellFooter/>
                                </Cell>
                            )
                           })
                         :
                            <div className="no-source-content">
                                <img src={defaultImg} alt="没有内容"/>
                                <p>sorry没有找到</p>
                            </div>
                          }
                        <p className="text-center text-minor margin-top">讲师管理后台：{config.ADMIN_BASE_URL}</p>
                    </div>
                </div>
            </Page>
        );
    }
};
export default connect((state) => ({}))(QuestionCategoryDetail)




// WEBPACK FOOTER //
// ./src/pages/QuestionCategoryDetail.js